<template>
  <div class="open-new-private">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: $const.route.OPEN_PRIVATE_DISPLAY }">业务申请</el-breadcrumb-item>
      <el-breadcrumb-item>申请私有云授权</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="appform">
      <div class="appform__header">
        <div class="title-cont">申请私有云授权</div>
      </div>
      <el-form :model="newPrivateData" :rules="rules" ref="form">

        <el-form-item
          class="private-form-item"
          label="申请服务:"
          prop="productids">
          <el-checkbox-group class="private-group"
            v-model="newPrivateData.productids"
            @change="handlePrivatetypeChange" >
            <div class="private-group-container"
              v-for="(items, index) in privateTypesConstant"
              :key="index">
              <div class="private-group-title">
                <span class="title-name">{{index}}</span>
                <span>（已选</span>
                <span class="choosen-num">{{privateTypesChoosenCount[index] || 0}}</span>
                <span>个）</span>
              </div>
              <div class="show-hide-private" :class="{'open-state' : privateTypesIsOpen[index]}" @click="handlePrivateTypesOpen(index)"></div>
              <div class="private-group-checkbox-status" :class="{'is-open': privateTypesIsOpen[index]}">
                <el-checkbox v-for="(item, idx) in items"
                  :key="idx"
                  :label="item.id"
                  :disabled="newPrivateData.productids.length > 0 && (privateBlushPalmsSDK.includes(item.id) && !newPrivateData.productids.includes(item.id) || (newPrivateData.productids.some(i => privateBlushPalmsSDK.includes(i)) && !newPrivateData.productids.includes(item.id)))"
                  :value="item.property">
                  <div>
                    <el-tooltip :content="item.name" placement="top-start" :open-delay="300">
                      <span class="show-item-name">{{item.name}}</span>
                    </el-tooltip>
                  </div>
                </el-checkbox>
              </div>
            </div>
          </el-checkbox-group>
        </el-form-item>

        <!-- <el-form-item label="优图接口人邮箱:" prop="youtucontacts" v-show="showInnerTable">
          <el-input v-model="newPrivateData.youtucontacts" placeholder="张三" :maxlength="100"></el-input>
          <div class="label-description">必须有优图商务、架构师等接口人对接，才可申请私有云授权，否则无法通过审核。</div>
        </el-form-item> -->

        <el-form-item label="优图接口人邮箱:" prop="ytcontact">
          <el-input v-model="newPrivateData.ytcontact" placeholder="zhangsan@tencent.com" :maxlength="100"></el-input>
          <div class="label-description">必须有优图商务、架构师等接口人对接，才可申请私有云授权，否则无法通过审核。</div>
        </el-form-item>

        <el-form-item label="应用场景:" prop="scene" class="scene-private">
          <el-input type="textarea" v-model="newPrivateData.scene"
            :placeholder="newPrivateData.productids.length === 1 && newPrivateData.productids.some((i) => privateBlushPalmsSDK.includes(i)) ? `QPS XX；掌库容量XX；空中开掌APP XX（可以不填）
使用场景：门禁/核身/支付/其他场景列举
使用国家和地区：
业务场景描述：` : '简要说明申请私有云的应用场景、需求、功能描述等(600字以内)'"
        :maxlength="600"></el-input>
        </el-form-item>

        <el-form-item label="授权方式:" prop="authtype">
          <el-radio-group v-model="newPrivateData.authtype">
            <el-radio
              v-for="authType in OptionMapper.AUTH_TYPE"
              :label="authType.value"
              :disabled="newPrivateData.productids.length === 1 && newPrivateData.productids.some((i) => privateBlushPalmsSDK.includes(i)) && authType.value === 1"
              :key="authType.value">{{authType.label}}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="授权机器:" prop="machinetype">
          <el-radio-group v-model="newPrivateData.machinetype">
            <el-radio
              v-for="machineType in OptionMapper.MECHINE_TYPE"
              :label="machineType.value"
              :disabled="newPrivateData.productids.length === 1 && newPrivateData.productids.some((i) => privateBlushPalmsSDK.includes(i)) && machineType.value === 2"
              :key="machineType.value">{{machineType.label}}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item prop="scope" class="form-item-left">
          <bubble
            slot="label"
            class="form-bubble"
            :bubbleInfo="tipConstant.scope">
          </bubble>
          <el-radio-group v-model="newPrivateData.scope">
            <el-radio v-for="scope in OptionMapper.MAINSTAY_TYPE" :label="scope.value" :key="scope.value">{{scope.label}}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item prop="applytype" class="form-item-left">
          <bubble
            slot="label"
            class="form-bubble"
            :bubbleInfo="tipConstant.applytype">
          </bubble>
          <el-radio-group v-model="newPrivateData.applytype">
            <el-radio :label="ApplyType.TEST">测试</el-radio>
            <el-radio :label="ApplyType.PRO">正式</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="`* ${contractText}:`" ref="contract" v-show="newPrivateData.applytype == ApplyType.PRO">
          <bubble
            slot="label"
            v-if="showInnerTable"
            :bubbleInfo="tipConstant.contract">
          </bubble>
          <form-item-upload-file
            :validateFile="validateFileContract"
            :twoM="true"
            :ErrorName="ErrorNameContract"
            :NeedConfirm="true"
            :noValidate="false"
            @validateInfoResult="handleValidateUploadResultContract($event, false)">
          </form-item-upload-file>
        </el-form-item>

        <el-form-item label="业务所属部门:" prop="intdept" v-show="showInnerTable">
          <el-input v-model="newPrivateData.intdept" placeholder="XXBG/XX部门" :maxlength="100"></el-input>
        </el-form-item>

        <el-form-item label="企业名称:" prop="extname" v-show="defaultExternal">
          <el-input v-model="newPrivateData.extname" placeholder="XXXX公司" :maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="企业网址:" prop="exturl" v-show="defaultExternal">
          <el-input v-model="newPrivateData.exturl" placeholder="www.xxx.com" :maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="业务接口人及联系方式:" prop="peercontact">
          <el-input v-model="newPrivateData.peercontact" placeholder="张三, 139......, zhangsan@qq.com" :maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="业务方邮件列表:" prop="mailreceiver">
          <el-input v-model="newPrivateData.mailreceiver" placeholder="xyz@qq.com" :maxlength="100"></el-input>
          <div class="label-description">授权到期、版本更新和交付等情况都将发送到这些邮箱，请如实填写。</div>
        </el-form-item>
        <el-form-item label="营业执照:" ref="licence" v-show="defaultExternal">
          <form-item-upload-file
            :validateFile="validateFileLicence"
            :ErrorName="ErrorNameLicence"
            :NeedConfirm="true"
            :noValidate="true"
            :twoM="true"
            @validateInfoResult="handleValidateUploadResultLicence($event, true)">
          </form-item-upload-file>
        </el-form-item>
        <el-form-item label="说明:" class="explain-info">
          <div>
            <span>两个工作日内完成审核，审核结果邮箱通知，请至业务申请页面查看审核结果并绑定设备。</span>
            <br>测试授权时间为申请完成之后起60天，正式授权时间为合同内签署的有效期。
            <br>测试版提供3台设备的授权，正式版将根据合同确定授权设备数量。
          </div>
        </el-form-item>
      </el-form>
      <button class="c-btn-add" @click="handleSubmitProcess">
        <span class="icon-plus"></span>
        <span class="text">提交申请</span>
      </button>
    </div>
  </div>

</template>
<script>
import PrivateCloudCreator from './js/PrivateCloudCreator';
export default PrivateCloudCreator;
</script>
<style lang="less">
@import "../../../../../styles/form.less";
@import "./css/private-cloud-creator.less";
</style>



// WEBPACK FOOTER //
// src/components/open/panels/application/panels/PrivateCloudCreator.vue